import { render } from "./RegistroDatosPersonalesDos.vue?vue&type=template&id=9e76708e&scoped=true"
import script from "./RegistroDatosPersonalesDos.vue?vue&type=script&lang=js"
export * from "./RegistroDatosPersonalesDos.vue?vue&type=script&lang=js"

import "./RegistroDatosPersonalesDos.vue?vue&type=style&index=0&id=9e76708e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e76708e"]])

export default __exports__